import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=45adb441&scoped=true&"
import script from "./withdraw.vue?vue&type=script&lang=js&"
export * from "./withdraw.vue?vue&type=script&lang=js&"
import style0 from "./withdraw.vue?vue&type=style&index=0&id=45adb441&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45adb441",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45adb441')) {
      api.createRecord('45adb441', component.options)
    } else {
      api.reload('45adb441', component.options)
    }
    module.hot.accept("./withdraw.vue?vue&type=template&id=45adb441&scoped=true&", function () {
      api.rerender('45adb441', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/supervision/recommend/components/withdraw.vue"
export default component.exports